<footer id="footer" class="d-flex justify-content-center align-items-center p-3">
  <p class="m-0 text-center">© 2026 - HubbleHox Technologies Pvt. Ltd. | All Rights Reserved</p>
</footer>
